
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/espace-assurance",
      function () {
        return require("private-next-pages/espace-assurance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/espace-assurance"])
      });
    }
  